<template>
    <div v-if="!tech">
        <div class="container" style="padding-top: 35px;">
            <div class="">
                <p>Categories</p>
                <p>https://api.alfastar.kz/api/v1/client/categories</p>
                <p>Result: <br></p>
                <pre>
        {
            "categories": [
                {
                    "id": 95,
                    "vendor_code": null,
                    "name": "Программное обеспечение для компьютеров",
                    "alias": "programmnoe-obespechenie-dlya-kompyuterov-95",
                    "desc": null,
                    "image": null,
                    "created_at": "2020-06-18 11:58:59",
                    "updated_at": "2020-06-25 10:54:13",
                    "v1c_id": "00000000154"
                },
                {
                    "id": 96,
                    "vendor_code": null,
                    "name": "Наушники",
                    "alias": "naushniki-96",
                    "desc": null,
                    "image": null,
                    "created_at": "2020-06-18 11:58:59",
                    "updated_at": "2020-06-18 11:58:59",
                    "v1c_id": "00000000085"
                },
                {
                    "id": 97,
                    "vendor_code": null,
                    "name": "Моноблоки",
                    "alias": "monobloki-97",
                    "desc": null,
                    "image": null,
                    "created_at": "2020-06-18 11:58:59",
                    "updated_at": "2020-06-18 11:58:59",
                    "v1c_id": "00000000448"
                },
                ...
            ]
        }
                </pre>
                <hr>
            </div>

            <div class="">
                <p>Products</p>
                <p>https://api.alfastar.kz/api/v1/client/products?category_id=000000006</p>
                <p>Result: <br></p>
                <pre>
        {
            "products": [
                {
                    "id": 350,
                    "category_id": "00000000685",
                    "vendor_code": "4 712960 683259",
                    "alias": "solid-state-drive-tverdotelnyy-nakopitel-s100-120gb-350",
                    "name": "SOLID STATE DRIVE (Твердотельный накопитель) S100-120GB",
                    "full_name": null,
                    "short_desc": null,
                    "desc": null,
                    "image": "ac40c841-afce-11ea-80f4-941882080c9c.png",
                    "images": "[\"ac40c841-afce-11ea-80f4-941882080c9c.png\",\"ac40c842-afce-11ea-80f4-941882080c9c.jpg\"]",
                    "remain": 125,
                    "price_dealer": 10223,
                    "price_wholesale": null,
                    "price_retail": null,
                    "package": null,
                    "created_at": "2020-06-25 10:38:31",
                    "updated_at": "2020-06-25 10:38:31",
                    "v1c_id": "00000001391"
                },
                ...
            ]
        }
                    </pre>
                <hr>
            </div>
        </div>
    </div>

    <div v-else>
        <div class="text-center mt-5">Техничесике неполадки. Свяжитесь с менеджером: +7 747 717 60 60</div>
    </div>
    
</template>

<script>
    export default {
        name: "GetApi",
        data() {
            return {
                tech: false
            }
        },

        mounted() {
            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'API'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.tech = true
                    }
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/pages/GetApi.vue